import "./sentry";
import "regenerator-runtime/runtime.js";
import * as pc from "playcanvas";
import * as smoothscroll from "smoothscroll-polyfill";
import { makeMouseEventsScoped } from "@animech/playcanvas-utilities";
import { Bootstrapper } from "./core/bootstrapper";

// Global pc context is required to run PlayCanvas scripts
// exported from PlayCanvas editor
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).pc = pc;

makeMouseEventsScoped();

smoothscroll.polyfill();

new Bootstrapper().start();
